module.exports = __webpack_public_path__ + "static/magazine-176aa15a262f9d52ee0fe57c2b2016ef.jpg";